// Auth0 Configuration
// Update these values with your Auth0 application settings from the Auth0 Dashboard

import { getEnvVar } from '../utils/authUtils'

export const auth0Config = {
  domain: getEnvVar('REACT_APP_AUTH0_DOMAIN'), 
  clientId: getEnvVar('REACT_APP_AUTH0_CLIENT_ID'),
  redirectUri: getEnvVar('REACT_APP_AUTH0_CALLBACK_URL') || `${window.location.origin}`,
  audience: getEnvVar('REACT_APP_AUTH0_AUDIENCE'),
  hardcoded : getEnvVar('REACT_TEST_VAL') || 'ALERT - Vault values are not fetching (Callback error msg is showing)',
};

